<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>noise_control_off</mat-icon>
        <div>Expositores</div>
      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card>

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>noise_control_off</mat-icon>
          <div>Manual</div>
        </ng-template>


        <!-- TABLE -->
        <mat-table [dataSource]="dataSource" matSort matSortActive="position" matSortDirection='asc'
          matSortDisableClear=true>

          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon class="icon-dot">noise_control_off</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- position Column -->
          <ng-container matColumnDef="position">
            <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.position }} </mat-cell>
          </ng-container>

          <!-- period Column -->
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Título </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.title }} </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDialog(element)' matTooltip='Editar' style="background-color: whitesmoke;">
                <mat-icon class='icon-info'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- preview Column -->
          <ng-container matColumnDef="preview">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='previewContent(element)' matTooltip='Prévia' style='background-color: whitesmoke;'>
                <mat-icon class='icon-add'>
                  preview
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef>
              <a mat-button (click)="openDialog(null)" matTooltip='Novo' style="width:60px;">
                <mat-icon color='primary'>add_circle_outline</mat-icon>
              </a>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDelete(element)' matTooltip='Apagar' style='background-color: whitesmoke;'>
                <mat-icon class='icon-delete' style="font-size:1.5em;">delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>


          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->


      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>noise_control_off</mat-icon>
          <div>Formulários</div>
        </ng-template>

          <!-- TABLE -->
          <mat-table [dataSource]="dataSourcePDF" matSort matSortActive="period" matSortDirection='desc'
            matSortDisableClear=true >

            <!-- Icon Column -->
            <ng-container matColumnDef="icon">
              <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <mat-icon class="icon-dot">noise_control_off</mat-icon>
              </mat-cell>
            </ng-container>

            <!-- Chave Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.name }}
              </mat-cell>
            </ng-container>

            <!-- file Column -->
            <ng-container matColumnDef="file">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Arquivo </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.pdf_name }}
              </mat-cell>
            </ng-container>

            <!-- copy Column -->
            <ng-container matColumnDef="copy">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)="copyToClipboard('https://sbccv.org.br/downloads/' + element.key)"
                  style="background-color: whitesmoke;">
                  <mat-icon class="icon-done">content_copy</mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- preview Column -->
            <ng-container matColumnDef="preview">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button target="_blank" [href]="'https://sbccv.org.br/pdf/' + element.key"
                  style='background-color: whitesmoke;'>
                  <mat-icon class='icon-add'>
                    preview
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- edit Column -->
            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openDialogPDF(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- delete Column -->
            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <a mat-button (click)="openDialogPDF(null)" style='width:60px;'>
                  <mat-icon class="icon-add">add_circle_outline</mat-icon>
                </a>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openDeletePDF(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-delete'>delete_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>


            <!-- Header -->
            <mat-header-row *matHeaderRowDef="displayedPDFColumns; sticky: true;"></mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedPDFColumns;"></mat-row>

          </mat-table>
          <!-- END TABLE -->

      </mat-tab>

    </mat-tab-group>

  </mat-card>

</div>